import React, { Component } from 'react'
import { translate } from 'react-i18next'
import Checkbox from '../../../UI/Checkbox'
import { graphql, compose } from 'react-apollo'
import SERVICE_OFFER from './../../../../graphql/ServiceOffer.graphql'
const R = require('ramda')

class AdditionalServices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      additionalServices: false,
      requiredServices: [],
      serviceNames: []
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  toggleOptions = () => {
    this.setState(
      {
        additionalServices: !this.state.additionalServices,
        requiredServices: [],
        serviceNames: []
      },
      () => this.props.updateState(this.state)
    )
  }

  toggleService = event => {
    const serv = this.state.requiredServices
    const names = this.state.serviceNames
    const index = serv.indexOf(Number(event.target.id))
    if (this.state.requiredServices.includes(Number(event.target.id))) {
      this.setState(
        {
          requiredServices: R.remove(index, 1, serv),
          serviceNames: R.remove(index, 1, names)
        },
        () => this.props.updateState(this.state)
      )
    } else {
      this.setState(
        {
          requiredServices: [...serv, Number(event.target.id)],
          serviceNames: [
            ...this.state.serviceNames,
            {
              name: this.props.data.allServiceOffers[Number(event.target.id)].service,
              price: this.props.data.allServiceOffers[Number(event.target.id)].price
            }
          ]
        },
        () => this.props.updateState(this.state)
      )
    }
    {
      /*   const {requiredServices, serviceNames} = this.state
    let index

    if (event.target.checked) {
      requiredServices.push(event.target.value)
      serviceNames.push({
        name: event.target.value,
        price: parseInt(event.target.id)
      })

    } else {
      index = serviceNames.indexOf(event.target.value)
      requiredServices.splice(index, 1)
      serviceNames.splice(index, 1)
    }

    const servicesTotal = serviceNames.map((service) => {
      return service.price
    }).reduce((prev, curr) => {
      return prev + curr;
    }, 0)

    this.setState({
      requiredServices: requiredServices ,
      serviceNames: serviceNames,
      servicesTotal: servicesTotal
    }, () => {
      this.props.updateState(this.state)
    })}*/
    }
  }

  componentWillUnmount() {
    this.props.updateState(this.state)
  }

  render() {
    const { t, data } = this.props
    return (
      <div className="additional-services">
        <h2 className="section-title">{t('additional_services')}</h2>

        <Checkbox handleChange={this.toggleOptions} value={this.state.additionalServices} checked={this.state.additionalServices} id="ofc">
          {t('ofc')}
        </Checkbox>

        <div className={this.state.additionalServices ? 'extra-services' : 'hidden'}>
          <h3 className="sub-header">{t('choose_services')}</h3>

          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              {data.allServiceOffers
                ? data.allServiceOffers.map((offer, index) => {
                    console.log('offer ------- ', offer)
                    return (
                      <div style={{ marginBottom: '15px' }} key={index}>
                        <Checkbox
                          value={offer.service}
                          checked={this.state.requiredServices.includes(index)}
                          handleChange={this.toggleService}
                          id={'' + index}
                        >
                          {`${t(offer.service)} - $${offer.price}`}
                        </Checkbox>
                        <div style={{ marginTop: '-7px' }}>
                          <div style={{ fontSize: '16px', paddingLeft: '36px' }}>
                            {offer.description ? offer.description : 'description not provided'}
                          </div>
                        </div>
                      </div>
                    )
                  })
                : ''}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6" />
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('booking_steps'),
  graphql(SERVICE_OFFER, {
    options: props => ({
      fetchPolicy: 'network-only'
    })
  })
)

export default enhance(AdditionalServices)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Steps/AdditionalServices.jsx